import { Component, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { BaseView } from '@wizeoo/akm-common-lib';
@Component({
  selector: 'newtab-view',
  templateUrl: './newtab.view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewtabView extends BaseView {
  
  constructor(elementRef: ElementRef, protected cdref: ChangeDetectorRef) {
    super(elementRef);
  }

}
